@import "../../global/normalize.css";

:host {
  display: block;
  margin-right: var(--ic-space-xs);
  list-style: none;
}

:host(.in-side-menu) {
  margin-right: 0;
}

:host::part(button) {
  height: 100%;
  min-height: 2.5rem;
}

:host(:not(.in-side-menu)) ::part(button):focus {
  box-shadow: var(--ic-border-focus-light);
}

:host(:not(.in-side-menu).dark) ::part(button):focus {
  box-shadow: var(--ic-border-focus-dark);
}

:host(.in-side-menu) ::part(button) {
  color: var(--ic-top-navigation-icon-active);
}

:host(.in-side-menu) ::part(button):hover {
  color: var(--ic-top-navigation-icon-hover);
  background-color: var(--ic-top-navigation-icon-hover-background);
}

:host(.in-side-menu) ::part(button):active {
  color: var(--ic-top-navigation-icon-pressed);
  background-color: var(--ic-top-navigation-icon-pressed-background);
}

:host(.in-side-menu) ::slotted(ic-badge) {
  margin-left: var(--ic-space-xs);
}
